import { useNavigate, useLocation } from 'react-router-dom';

const tabs = [
  { path: '/laborantin/dashboard', label: 'Tableau de bord' },
  { path: '/laborantin/saisir-analyses', label: 'Saisir analyses' },
  { path: '/laborantin/valeurs-reference', label: 'Valeurs de référence' },
];

export default function LabNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActiveTab = (tabPath: string) => {
    if (location.pathname === tabPath) return true;
    if (tabPath === '/laborantin/saisir-analyses' && location.pathname.startsWith('/laborantin/rapport-analyses')) return true;
    return false;
  };

  return (
    <div className="flex items-center gap-1 bg-white border border-gray-100 p-1 rounded-full w-fit">
      {tabs.map(tab => {
        const active = isActiveTab(tab.path);
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`px-4 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all ${
              active
                ? 'bg-clinic-blue/10 text-clinic-blue-dark'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}